export default __webpack_public_path__ + "static/Gelion-Regular-89562b4622edb2fbe2e50118956db371.woff2";